const UidispatcherApiModule = await import("uidispatcher_api/UidispatcherApiModule");
export const AnonymousCartMetaStore = UidispatcherApiModule.AnonymousCartMetaStore;
